/**
 * Moon & Space — rocket pad on Sunset Shore, moon surface, the owner's 7-level
 * Space Mansion (basement + 6 floors incl. Morgan's room), Randall's Moon Base,
 * shaped photo frames, and free-flight space cruising in a mini spacecraft.
 */

export const ROCKET_PAD = { x: 80, y: 5810 };

// moon surface interactive zones (interior coordinate space 800x520)
export const MOON_DOORS = {
  mansion: { x: 250, y: 300, w: 170, h: 150 },
  randall: { x: 615, y: 315, w: 130, h: 120 },
  rocket: { x: 90, y: 445, r: 60 },
  craft: { x: 720, y: 450, r: 55 },
};

// space free-flight world
export const SPACE_W = 2000;
export const SPACE_H = 1400;
export const SPACE_MOON = { x: 1680, y: 1150, r: 95 };
export const PLANETS = [
  { id: 'mars', name: 'MARS', x: 700, y: 1050, r: 46 },
  { id: 'venus', name: 'VENUS', x: 380, y: 660, r: 52 },
  { id: 'saturn', name: 'SATURN', x: 1500, y: 320, r: 58 },
];

// ==================== ROCKET ====================
export function drawRocketShape(ctx, x, y, s, t, flame) {
  ctx.save();
  ctx.translate(x, y);
  // fins
  ctx.fillStyle = '#dc2626';
  ctx.beginPath(); ctx.moveTo(-14 * s, 6 * s); ctx.lineTo(-26 * s, 26 * s); ctx.lineTo(-12 * s, 20 * s); ctx.closePath(); ctx.fill();
  ctx.beginPath(); ctx.moveTo(14 * s, 6 * s); ctx.lineTo(26 * s, 26 * s); ctx.lineTo(12 * s, 20 * s); ctx.closePath(); ctx.fill();
  // body
  ctx.fillStyle = '#e5e7eb';
  ctx.beginPath();
  ctx.moveTo(0, -52 * s);
  ctx.quadraticCurveTo(16 * s, -30 * s, 15 * s, 8 * s);
  ctx.lineTo(15 * s, 22 * s); ctx.lineTo(-15 * s, 22 * s); ctx.lineTo(-15 * s, 8 * s);
  ctx.quadraticCurveTo(-16 * s, -30 * s, 0, -52 * s);
  ctx.fill();
  // nose cone
  ctx.fillStyle = '#dc2626';
  ctx.beginPath(); ctx.moveTo(0, -52 * s);
  ctx.quadraticCurveTo(13 * s, -38 * s, 14 * s, -26 * s);
  ctx.lineTo(-14 * s, -26 * s);
  ctx.quadraticCurveTo(-13 * s, -38 * s, 0, -52 * s); ctx.fill();
  // porthole
  ctx.fillStyle = '#38bdf8';
  ctx.beginPath(); ctx.arc(0, -8 * s, 7 * s, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = '#94a3b8'; ctx.lineWidth = 2 * s;
  ctx.beginPath(); ctx.arc(0, -8 * s, 7 * s, 0, Math.PI * 2); ctx.stroke();
  if (flame) {
    const fl = 18 + Math.abs(Math.sin(t * 0.4)) * 22;
    ctx.fillStyle = '#f97316';
    ctx.beginPath(); ctx.moveTo(-10 * s, 22 * s); ctx.lineTo(0, (22 + fl) * s); ctx.lineTo(10 * s, 22 * s); ctx.closePath(); ctx.fill();
    ctx.fillStyle = '#fde047';
    ctx.beginPath(); ctx.moveTo(-5 * s, 22 * s); ctx.lineTo(0, (22 + fl * 0.6) * s); ctx.lineTo(5 * s, 22 * s); ctx.closePath(); ctx.fill();
  }
  ctx.restore();
}

// launch pad on the beach (street mode, y-camera only). launchP: 0..1 while lifting off
export function drawRocketPad(ctx, cam, t, launchP) {
  const py = ROCKET_PAD.y - cam;
  if (py < -700 || py > ctx.canvas.height + 100) return;
  // concrete pad
  ctx.fillStyle = '#6b7280';
  ctx.beginPath(); ctx.ellipse(ROCKET_PAD.x, py + 24, 62, 20, 0, 0, Math.PI * 2); ctx.fill();
  ctx.strokeStyle = '#fbbf24'; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.ellipse(ROCKET_PAD.x, py + 24, 62, 20, 0, 0, Math.PI * 2); ctx.stroke();
  ctx.fillStyle = '#374151';
  ctx.beginPath(); ctx.ellipse(ROCKET_PAD.x, py + 22, 44, 13, 0, 0, Math.PI * 2); ctx.fill();
  // blink lights
  for (let i = 0; i < 6; i++) {
    const a = (i / 6) * Math.PI * 2;
    const on = (Math.floor(t / 18) + i) % 3 === 0;
    ctx.fillStyle = on ? '#f87171' : '#7f1d1d';
    ctx.beginPath(); ctx.arc(ROCKET_PAD.x + Math.cos(a) * 58, py + 24 + Math.sin(a) * 17, 3, 0, Math.PI * 2); ctx.fill();
  }
  // rocket (rises during launch)
  const rise = launchP ? launchP * launchP * 640 : 0;
  const shake = launchP && launchP < 0.35 ? Math.sin(t * 1.6) * 2.4 : 0;
  const rocketX = ROCKET_PAD.x + shake;
  const rocketY = py - 4 - rise;
  drawRocketShape(ctx, rocketX, rocketY, 1.15, t, !!launchP);
  if (launchP) {
    // smoke billow at the pad
    for (let i = 0; i < 7; i++) {
      ctx.fillStyle = `rgba(226,232,240,${0.4 - i * 0.05})`;
      ctx.beginPath();
      ctx.arc(ROCKET_PAD.x - 40 + i * 14 + Math.sin(t * 0.3 + i) * 6, py + 18 - Math.abs(Math.sin(t * 0.2 + i)) * 10, 10 + i * 2, 0, Math.PI * 2);
      ctx.fill();
    }
  } else {
    ctx.font = 'bold 10px monospace'; ctx.textAlign = 'center';
    ctx.fillStyle = 'rgba(0,0,0,0.65)';
    ctx.fillRect(ROCKET_PAD.x - 82, py - 84, 180, 18);
    ctx.fillStyle = `rgba(125,211,252,${0.7 + Math.abs(Math.sin(t * 0.07)) * 0.3})`;
    ctx.shadowColor = '#38bdf8'; ctx.shadowBlur = 8;
    ctx.fillText('🚀 TAP TO FLY TO THE MOON', ROCKET_PAD.x + 8, py - 71);
    ctx.shadowBlur = 0;
  }
  return { x: rocketX, y: rocketY, s: 1.15 };
}

// ==================== SHAPED PHOTO FRAMES ====================
export const SPACE_FRAME_SLOTS = [
  { room: 'sp_lobby', x: 150, y: 150, shape: 'hex', s: 52 },
  { room: 'sp_lobby', x: 650, y: 150, shape: 'circle', s: 48 },
  { room: 'sp_morgan', x: 140, y: 140, shape: 'heart', s: 48 },
  { room: 'sp_morgan', x: 400, y: 108, shape: 'circle', s: 40 },
  { room: 'sp_morgan', x: 660, y: 140, shape: 'star', s: 50 },
  { room: 'sp_gallery', x: 130, y: 130, shape: 'wide', s: 62 },
  { room: 'sp_gallery', x: 320, y: 118, shape: 'circle', s: 44 },
  { room: 'sp_gallery', x: 500, y: 130, shape: 'diamond', s: 52 },
  { room: 'sp_gallery', x: 680, y: 122, shape: 'tall', s: 54 },
  { room: 'sp_gallery', x: 220, y: 252, shape: 'star', s: 46 },
  { room: 'sp_gallery', x: 590, y: 252, shape: 'hex', s: 48 },
  { room: 'sp_lounge', x: 150, y: 140, shape: 'oval', s: 54 },
  { room: 'sp_lounge', x: 400, y: 104, shape: 'wide', s: 64 },
  { room: 'sp_lounge', x: 650, y: 140, shape: 'circle', s: 44 },
  { room: 'sp_pool', x: 140, y: 130, shape: 'circle', s: 42 },
  { room: 'sp_pool', x: 660, y: 130, shape: 'hex', s: 46 },
  { room: 'sp_observatory', x: 150, y: 156, shape: 'star', s: 50 },
  { room: 'sp_observatory', x: 650, y: 156, shape: 'diamond', s: 48 },
  { room: 'mr_base', x: 205, y: 120, shape: 'star', s: 44 },
  { room: 'mr_base', x: 400, y: 330, shape: 'wide', s: 50 },
  { room: 'mr_base', x: 545, y: 110, shape: 'hex', s: 42 },
];

function framePath(ctx, f) {
  const { x, y, s, shape } = f;
  ctx.beginPath();
  if (shape === 'circle') ctx.arc(x, y, s, 0, Math.PI * 2);
  else if (shape === 'oval') ctx.ellipse(x, y, s * 1.25, s * 0.85, 0, 0, Math.PI * 2);
  else if (shape === 'wide') { const w = s * 1.5, h = s; ctx.rect(x - w, y - h, w * 2, h * 2); }
  else if (shape === 'tall') { const w = s * 0.75, h = s * 1.2; ctx.rect(x - w, y - h, w * 2, h * 2); }
  else if (shape === 'diamond') { ctx.moveTo(x, y - s); ctx.lineTo(x + s, y); ctx.lineTo(x, y + s); ctx.lineTo(x - s, y); ctx.closePath(); }
  else if (shape === 'hex') {
    for (let i = 0; i < 6; i++) {
      const a = (i / 6) * Math.PI * 2 - Math.PI / 2;
      const px = x + Math.cos(a) * s, py = y + Math.sin(a) * s;
      i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
    }
    ctx.closePath();
  } else if (shape === 'star') {
    for (let i = 0; i < 10; i++) {
      const a = (i / 10) * Math.PI * 2 - Math.PI / 2;
      const r = i % 2 === 0 ? s : s * 0.46;
      const px = x + Math.cos(a) * r, py = y + Math.sin(a) * r;
      i === 0 ? ctx.moveTo(px, py) : ctx.lineTo(px, py);
    }
    ctx.closePath();
  } else if (shape === 'heart') {
    ctx.moveTo(x, y + s * 0.85);
    ctx.bezierCurveTo(x - s * 1.35, y - s * 0.15, x - s * 0.6, y - s * 1.05, x, y - s * 0.35);
    ctx.bezierCurveTo(x + s * 0.6, y - s * 1.05, x + s * 1.35, y - s * 0.15, x, y + s * 0.85);
    ctx.closePath();
  }
}

export function drawSpaceFrames(ctx, room, photos, imgFor, canEdit, t) {
  SPACE_FRAME_SLOTS.forEach((f, i) => {
    if (f.room !== room) return;
    const url = (photos || {})[String(i)];
    ctx.save();
    // glow border
    ctx.shadowColor = url ? '#fbbf24' : 'rgba(251,191,36,0.4)';
    ctx.shadowBlur = 8 + Math.abs(Math.sin(t * 0.05 + i)) * 5;
    ctx.fillStyle = '#0e0a14';
    framePath(ctx, f); ctx.fill();
    ctx.shadowBlur = 0;
    ctx.strokeStyle = '#b8860b'; ctx.lineWidth = 5;
    framePath(ctx, f); ctx.stroke();
    ctx.strokeStyle = '#fde68a'; ctx.lineWidth = 1.5;
    framePath(ctx, f); ctx.stroke();
    if (url) {
      const im = imgFor(url);
      if (im.complete && im.naturalWidth > 0) {
        ctx.save();
        framePath(ctx, f); ctx.clip();
        const bw = f.s * 3, bh = f.s * 3;
        const sc = Math.max(bw / im.naturalWidth, bh / im.naturalHeight);
        const sw = bw / sc, sh = bh / sc;
        ctx.drawImage(im, (im.naturalWidth - sw) / 2, (im.naturalHeight - sh) / 2, sw, sh, f.x - bw / 2, f.y - bh / 2, bw, bh);
        ctx.restore();
      }
    } else {
      ctx.font = '18px sans-serif'; ctx.textAlign = 'center';
      ctx.fillStyle = 'rgba(255,255,255,0.3)';
      ctx.fillText(canEdit ? '+' : '🖼', f.x, f.y + 6);
      if (canEdit) {
        ctx.font = '8px sans-serif';
        ctx.fillText('tap to add', f.x, f.y + 20);
      }
    }
    ctx.restore();
  });
}

export function frameSlotAt(room, cx, cy) {
  for (let i = 0; i < SPACE_FRAME_SLOTS.length; i++) {
    const f = SPACE_FRAME_SLOTS[i];
    if (f.room !== room) continue;
    const rx = f.shape === 'wide' ? f.s * 1.5 : f.shape === 'oval' ? f.s * 1.25 : f.s;
    const ry = f.shape === 'tall' ? f.s * 1.2 : f.s;
    if (Math.abs(cx - f.x) < rx + 8 && Math.abs(cy - f.y) < ry + 8) return i;
  }
  return -1;
}

// ==================== MOON ROOMS ====================
function stars(ctx, t, count, yMax) {
  for (let i = 0; i < count; i++) {
    const sx = (i * 137) % 790; const sy = 20 + ((i * 211) % yMax);
    const tw = 0.3 + Math.abs(Math.sin(t * 0.05 + i)) * 0.7;
    ctx.fillStyle = `rgba(255,255,255,${tw})`;
    ctx.fillRect(sx, sy, i % 9 === 0 ? 2.5 : 1.5, i % 9 === 0 ? 2.5 : 1.5);
  }
}

export function drawMoonRoom(ctx, sub, t, opts = {}) {
  ctx.save();
  ctx.textAlign = 'center';
  if (sub === 'moon_surface') {
    stars(ctx, t, 70, 220);
    // Earth in the black sky
    const eg = ctx.createRadialGradient(112, 84, 8, 118, 90, 34);
    eg.addColorStop(0, '#7dd3fc'); eg.addColorStop(0.6, '#2563eb'); eg.addColorStop(1, '#1e3a8a');
    ctx.fillStyle = eg;
    ctx.beginPath(); ctx.arc(118, 90, 32, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = 'rgba(74,222,128,0.75)';
    ctx.beginPath(); ctx.ellipse(108, 82, 12, 7, 0.5, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath(); ctx.ellipse(128, 100, 9, 5, -0.4, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = 'rgba(255,255,255,0.35)';
    ctx.beginPath(); ctx.ellipse(120, 88, 26, 10, 0.7, 0, Math.PI * 2); ctx.fill();
    ctx.font = '9px monospace'; ctx.fillStyle = 'rgba(125,211,252,0.6)';
    ctx.fillText('🌍 home', 118, 138);
    // lunar ground
    ctx.fillStyle = '#9ca3af';
    ctx.fillRect(0, 250, 800, 270);
    ctx.fillStyle = '#6b7280';
    [[120, 380, 44, 14], [420, 470, 60, 18], [660, 396, 36, 12], [270, 458, 30, 10]].forEach(([cx2, cy2, rx, ry]) => {
      ctx.beginPath(); ctx.ellipse(cx2, cy2, rx, ry, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#4b5563';
      ctx.beginPath(); ctx.ellipse(cx2, cy2 + 2, rx * 0.7, ry * 0.7, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#6b7280';
    });
    // ===== SPACE MANSION (7 levels: basement + 6 floors) =====
    const mx = 265;
    ctx.fillStyle = '#1e1b3a';
    ctx.fillRect(mx - 95, 62, 190, 218);
    ctx.strokeStyle = '#38bdf8'; ctx.lineWidth = 3;
    ctx.strokeRect(mx - 95, 62, 190, 218);
    for (let fl = 0; fl < 6; fl++) {
      const fy = 70 + fl * 34;
      ctx.strokeStyle = 'rgba(56,189,248,0.25)'; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(mx - 95, fy + 30); ctx.lineTo(mx + 95, fy + 30); ctx.stroke();
      [-64, -12, 40].forEach((wo, wi) => {
        const on = ((fl * 3 + wi + Math.floor(t / 50)) % 4) !== 0;
        ctx.fillStyle = on ? 'rgba(165,243,252,0.85)' : 'rgba(15,10,40,0.9)';
        ctx.fillRect(mx + wo, fy + 6, 24, 18);
      });
    }
    // glass dome on top
    ctx.fillStyle = 'rgba(125,211,252,0.18)';
    ctx.beginPath(); ctx.arc(mx, 64, 58, Math.PI, 0); ctx.fill();
    ctx.strokeStyle = '#7dd3fc'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.arc(mx, 64, 58, Math.PI, 0); ctx.stroke();
    // entrance airlock
    ctx.fillStyle = '#0c4a6e';
    ctx.fillRect(mx - 30, 300, 60, 62);
    ctx.strokeStyle = '#38bdf8'; ctx.lineWidth = 3;
    ctx.strokeRect(mx - 30, 300, 60, 62);
    ctx.fillStyle = 'rgba(56,189,248,0.5)';
    ctx.beginPath(); ctx.arc(mx, 324, 12, 0, Math.PI * 2); ctx.fill();
    // ramp
    ctx.fillStyle = '#94a3b8';
    ctx.beginPath(); ctx.moveTo(mx - 44, 364); ctx.lineTo(mx + 44, 364); ctx.lineTo(mx + 60, 392); ctx.lineTo(mx - 60, 392); ctx.closePath(); ctx.fill();
    const gl = 0.6 + Math.abs(Math.sin(t * 0.07)) * 0.4;
    ctx.font = 'bold 13px monospace';
    ctx.fillStyle = `rgba(125,211,252,${gl})`;
    ctx.shadowColor = '#38bdf8'; ctx.shadowBlur = 12 * gl;
    ctx.fillText('✦ SPACE MANSION ✦', mx, 292);
    ctx.shadowBlur = 0;
    ctx.font = 'bold 8px monospace';
    ctx.fillStyle = 'rgba(0,0,0,0.65)';
    ctx.fillRect(mx - 92, 396, 184, 14);
    ctx.fillStyle = 'rgba(255,255,255,0.85)';
    ctx.fillText('VIP & OWNERS · tap the airlock', mx, 406);
    // ===== RANDALL'S MOON BASE =====
    const rx = 640;
    ctx.fillStyle = 'rgba(255,215,0,0.14)';
    ctx.beginPath(); ctx.arc(rx, 320, 78, Math.PI, 0); ctx.fill();
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 3;
    ctx.beginPath(); ctx.arc(rx, 320, 78, Math.PI, 0); ctx.stroke();
    ctx.fillStyle = '#171022';
    ctx.beginPath(); ctx.arc(rx, 320, 64, Math.PI, 0); ctx.fill();
    ctx.fillStyle = '#2b1c0e';
    ctx.fillRect(rx - 24, 292, 48, 44);
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 2;
    ctx.strokeRect(rx - 24, 292, 48, 44);
    const rg = 0.55 + Math.abs(Math.sin(t * 0.08)) * 0.45;
    ctx.fillStyle = 'rgba(0,0,0,0.65)';
    ctx.fillRect(rx - 92, 224, 184, 18);
    ctx.font = 'bold 11px monospace';
    ctx.fillStyle = `rgba(255,215,0,${0.7 + rg * 0.3})`;
    ctx.shadowColor = '#FFD700'; ctx.shadowBlur = 10 * rg;
    ctx.fillText("⚡ RANDALL'S MOON BASE ⚡", rx, 237);
    ctx.shadowBlur = 0;
    // parked rocket (fly home)
    drawRocketShape(ctx, MOON_DOORS.rocket.x, MOON_DOORS.rocket.y, 0.95, t, false);
    ctx.font = 'bold 9px monospace';
    ctx.fillStyle = 'rgba(0,0,0,0.65)';
    ctx.fillRect(MOON_DOORS.rocket.x - 42, MOON_DOORS.rocket.y - 80, 84, 15);
    ctx.fillStyle = `rgba(252,165,165,${0.7 + Math.abs(Math.sin(t * 0.07)) * 0.3})`;
    ctx.fillText('🚀 fly home', MOON_DOORS.rocket.x, MOON_DOORS.rocket.y - 69);
    // mini spacecraft (space cruise)
    const cy = MOON_DOORS.craft.y + Math.sin(t * 0.08) * 3;
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.beginPath(); ctx.ellipse(MOON_DOORS.craft.x, MOON_DOORS.craft.y + 22, 34, 8, 0, 0, Math.PI * 2); ctx.fill();
    drawShip(ctx, MOON_DOORS.craft.x, cy, 0, t, false);
    ctx.font = 'bold 9px monospace';
    ctx.fillStyle = 'rgba(0,0,0,0.65)';
    ctx.fillRect(MOON_DOORS.craft.x - 72, cy - 52, 126, 15);
    ctx.fillStyle = `rgba(216,180,254,${0.7 + Math.abs(Math.sin(t * 0.09)) * 0.3})`;
    ctx.fillText('🛸 tap to cruise space', MOON_DOORS.craft.x - 10, cy - 41);
    // flag
    ctx.strokeStyle = '#e5e7eb'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(480, 420); ctx.lineTo(480, 372); ctx.stroke();
    ctx.fillStyle = '#a855f7';
    ctx.fillRect(480, 372, 34, 18);
    ctx.font = 'bold 7px monospace'; ctx.fillStyle = '#fff';
    ctx.fillText('RZNT', 497, 384);
  } else if (sub === 'sp_basement') {
    // engine bay — reactor core
    ctx.fillStyle = '#111827';
    ctx.fillRect(300, 120, 200, 180);
    ctx.strokeStyle = '#334155'; ctx.lineWidth = 3;
    ctx.strokeRect(300, 120, 200, 180);
    const pump = 1 + Math.abs(Math.sin(t * 0.1)) * 0.3;
    const cg = ctx.createRadialGradient(400, 210, 4, 400, 210, 46 * pump);
    cg.addColorStop(0, '#a5f3fc'); cg.addColorStop(0.5, '#06b6d4'); cg.addColorStop(1, 'rgba(8,51,68,0)');
    ctx.fillStyle = cg;
    ctx.beginPath(); ctx.arc(400, 210, 46 * pump, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#22d3ee'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.arc(400, 210, 26, 0, Math.PI * 2); ctx.stroke();
    // pipes
    ctx.strokeStyle = '#475569'; ctx.lineWidth = 8;
    ctx.beginPath(); ctx.moveTo(300, 160); ctx.lineTo(120, 160); ctx.lineTo(120, 290); ctx.stroke();
    ctx.beginPath(); ctx.moveTo(500, 160); ctx.lineTo(680, 160); ctx.lineTo(680, 290); ctx.stroke();
    // warning stripes
    for (let i = 0; i < 16; i++) {
      ctx.fillStyle = i % 2 ? '#facc15' : '#111';
      ctx.fillRect(60 + i * 44, 306, 44, 10);
    }
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(34,211,238,0.7)';
    ctx.fillText('⚛ GRAVITY CORE — ENGINE BAY ⚛', 400, 105);
  } else if (sub === 'sp_lobby') {
    stars(ctx, t, 40, 160);
    // hologram welcome desk
    ctx.fillStyle = '#1e293b';
    ctx.fillRect(330, 260, 140, 56);
    ctx.strokeStyle = '#38bdf8'; ctx.lineWidth = 2;
    ctx.strokeRect(330, 260, 140, 56);
    const hg = 0.4 + Math.abs(Math.sin(t * 0.09)) * 0.5;
    ctx.fillStyle = `rgba(56,189,248,${hg})`;
    ctx.font = 'bold 22px monospace';
    ctx.shadowColor = '#38bdf8'; ctx.shadowBlur = 14;
    ctx.fillText('WELCOME, STAR TRAVELER', 400, 220);
    ctx.shadowBlur = 0;
    // floating anti-grav orbs
    for (let i = 0; i < 5; i++) {
      const ox = 120 + i * 140;
      const oy = 150 + Math.sin(t * 0.05 + i * 1.4) * 22;
      ctx.fillStyle = `hsla(${(i * 60 + t) % 360}, 80%, 65%, 0.7)`;
      ctx.beginPath(); ctx.arc(ox, oy, 9, 0, Math.PI * 2); ctx.fill();
    }
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(255,255,255,0.5)';
    ctx.fillText('ZERO-G LOBBY · basement + 6 floors', 400, 330);
  } else if (sub === 'sp_morgan') {
    // MORGAN'S ROOM — super cute 💖
    // canopy bed
    ctx.fillStyle = '#f9a8d4';
    ctx.fillRect(110, 230, 190, 70);
    ctx.fillStyle = '#fdf2f8';
    ctx.fillRect(118, 218, 70, 26);
    ctx.strokeStyle = '#ec4899'; ctx.lineWidth = 3;
    ctx.strokeRect(110, 230, 190, 70);
    ctx.beginPath(); ctx.moveTo(110, 230); ctx.lineTo(110, 150); ctx.quadraticCurveTo(205, 118, 300, 150); ctx.lineTo(300, 230); ctx.stroke();
    ctx.fillStyle = 'rgba(249,168,212,0.28)';
    ctx.beginPath(); ctx.moveTo(110, 150); ctx.quadraticCurveTo(205, 118, 300, 150); ctx.lineTo(300, 230); ctx.lineTo(110, 230); ctx.closePath(); ctx.fill();
    // plushie row
    const plush = [['🐰', 350], ['🧸', 400], ['⭐', 450]];
    plush.forEach(([em, px]) => {
      ctx.font = '26px serif';
      ctx.fillText(em, px, 300 + Math.sin(t * 0.06 + px) * 3);
    });
    // vanity mirror
    ctx.fillStyle = '#fbcfe8';
    ctx.fillRect(560, 200, 130, 100);
    ctx.fillStyle = '#fdf2f8';
    ctx.beginPath(); ctx.ellipse(625, 236, 42, 30, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#f472b6'; ctx.lineWidth = 4;
    ctx.beginPath(); ctx.ellipse(625, 236, 42, 30, 0, 0, Math.PI * 2); ctx.stroke();
    // fairy light garland
    ctx.strokeStyle = 'rgba(244,114,182,0.6)'; ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(60, 74); ctx.quadraticCurveTo(400, 120, 740, 74); ctx.stroke();
    for (let i = 0; i < 12; i++) {
      const lx = 80 + i * 56;
      const ly = 78 + Math.sin((lx / 740) * Math.PI) * 36;
      const on = (Math.floor(t / 20) + i) % 3 !== 0;
      ctx.fillStyle = on ? ['#f9a8d4', '#fde047', '#a5f3fc'][i % 3] : 'rgba(255,255,255,0.2)';
      ctx.beginPath(); ctx.arc(lx, ly, 4, 0, Math.PI * 2); ctx.fill();
    }
    // floating hearts
    for (let i = 0; i < 6; i++) {
      const hy = 320 - ((t * 0.6 + i * 60) % 260);
      ctx.font = `${10 + (i % 3) * 4}px serif`;
      ctx.fillStyle = `rgba(244,114,182,${Math.max(0, 0.8 - (320 - hy) / 300)})`;
      ctx.fillText('💗', 90 + i * 120, hy);
    }
    const mg = 0.6 + Math.abs(Math.sin(t * 0.08)) * 0.4;
    ctx.font = 'bold 26px serif';
    ctx.fillStyle = `rgba(244,114,182,${mg})`;
    ctx.shadowColor = '#f472b6'; ctx.shadowBlur = 16 * mg;
    ctx.fillText('♡ MORGAN ♡', 400, 66);
    ctx.shadowBlur = 0;
  } else if (sub === 'sp_gallery') {
    // spotlights from ceiling (frames drawn separately)
    [130, 320, 500, 680].forEach((sx) => {
      ctx.fillStyle = 'rgba(253,230,138,0.06)';
      ctx.beginPath(); ctx.moveTo(sx, 60); ctx.lineTo(sx - 70, 320); ctx.lineTo(sx + 70, 320); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#333';
      ctx.fillRect(sx - 8, 52, 16, 10);
    });
    // velvet rope
    ctx.strokeStyle = '#dc2626'; ctx.lineWidth = 4;
    ctx.beginPath(); ctx.moveTo(80, 320); ctx.quadraticCurveTo(240, 344, 400, 320); ctx.quadraticCurveTo(560, 344, 720, 320); ctx.stroke();
    [80, 400, 720].forEach((px) => {
      ctx.fillStyle = '#b8860b';
      ctx.fillRect(px - 4, 320, 8, 34);
      ctx.beginPath(); ctx.arc(px, 318, 7, 0, Math.PI * 2); ctx.fill();
    });
    ctx.font = 'bold 11px monospace'; ctx.fillStyle = 'rgba(251,191,36,0.65)';
    ctx.fillText('🖼 HOLO GALLERY — trick the place out', 400, 42);
  } else if (sub === 'sp_lounge') {
    // nebula window
    const ng = ctx.createLinearGradient(260, 90, 540, 220);
    ng.addColorStop(0, '#7c3aed'); ng.addColorStop(0.5, '#db2777'); ng.addColorStop(1, '#1e3a8a');
    ctx.fillStyle = ng;
    ctx.fillRect(260, 84, 280, 140);
    stars(ctx, t, 20, 130);
    ctx.strokeStyle = '#94a3b8'; ctx.lineWidth = 5;
    ctx.strokeRect(260, 84, 280, 140);
    // curved sofa
    ctx.fillStyle = '#4c1d95';
    ctx.beginPath(); ctx.ellipse(400, 300, 190, 46, 0, 0, Math.PI); ctx.fill();
    ctx.fillStyle = '#6d28d9';
    ctx.beginPath(); ctx.ellipse(400, 292, 170, 34, 0, 0, Math.PI); ctx.fill();
    // chandelier of orbs
    for (let i = 0; i < 7; i++) {
      const a = (i / 7) * Math.PI * 2 + t * 0.015;
      ctx.fillStyle = `hsla(${(i * 51 + t * 2) % 360}, 85%, 70%, 0.8)`;
      ctx.beginPath(); ctx.arc(400 + Math.cos(a) * 40, 56 + Math.sin(a) * 12, 5, 0, Math.PI * 2); ctx.fill();
    }
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(216,180,254,0.7)';
    ctx.fillText('☄ NEBULA LOUNGE ☄', 400, 250);
  } else if (sub === 'sp_pool') {
    // anti-gravity water blob
    const wob = Math.sin(t * 0.06) * 8;
    const pg = ctx.createRadialGradient(400, 200, 10, 400, 200, 110);
    pg.addColorStop(0, '#7dd3fc'); pg.addColorStop(1, '#0369a1');
    ctx.fillStyle = pg;
    ctx.beginPath(); ctx.ellipse(400, 196, 130 + wob, 82 - wob * 0.5, 0, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,0.5)'; ctx.lineWidth = 2;
    ctx.beginPath(); ctx.ellipse(400, 196, 130 + wob, 82 - wob * 0.5, 0, 0, Math.PI * 2); ctx.stroke();
    // floating droplets
    for (let i = 0; i < 8; i++) {
      const dx = 200 + i * 60;
      const dy = 120 + Math.sin(t * 0.07 + i * 1.8) * 46;
      ctx.fillStyle = 'rgba(125,211,252,0.7)';
      ctx.beginPath(); ctx.arc(dx, dy, 4 + (i % 3) * 2, 0, Math.PI * 2); ctx.fill();
    }
    // ladder
    ctx.strokeStyle = '#e2e8f0'; ctx.lineWidth = 4;
    ctx.beginPath(); ctx.moveTo(560, 250); ctx.lineTo(560, 320); ctx.moveTo(586, 250); ctx.lineTo(586, 320); ctx.stroke();
    ctx.lineWidth = 2;
    for (let i = 0; i < 4; i++) { ctx.beginPath(); ctx.moveTo(560, 260 + i * 18); ctx.lineTo(586, 260 + i * 18); ctx.stroke(); }
    ctx.font = 'bold 10px monospace'; ctx.fillStyle = 'rgba(125,211,252,0.75)';
    ctx.fillText('💧 ANTI-GRAV POOL — the water floats!', 400, 330);
  } else if (sub === 'sp_observatory') {
    stars(ctx, t, 70, 240);
    // Saturn view
    ctx.fillStyle = '#fbbf24';
    ctx.beginPath(); ctx.arc(620, 110, 26, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = 'rgba(251,191,36,0.6)'; ctx.lineWidth = 5;
    ctx.beginPath(); ctx.ellipse(620, 110, 46, 11, -0.35, 0, Math.PI * 2); ctx.stroke();
    // shooting star
    const sh = (t * 1.6) % 800;
    if (sh < 260) {
      ctx.strokeStyle = `rgba(255,255,255,${0.85 - sh / 300})`; ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(60 + sh * 2.4, 60 + sh * 0.5); ctx.lineTo(96 + sh * 2.4, 74 + sh * 0.5); ctx.stroke();
    }
    // big telescope
    ctx.fillStyle = '#334155';
    ctx.fillRect(340, 260, 110, 62);
    ctx.strokeStyle = '#94a3b8'; ctx.lineWidth = 14;
    ctx.beginPath(); ctx.moveTo(395, 268); ctx.lineTo(490, 140); ctx.stroke();
    ctx.strokeStyle = '#e2e8f0'; ctx.lineWidth = 6;
    ctx.beginPath(); ctx.moveTo(478, 156); ctx.lineTo(508, 116); ctx.stroke();
    // glass dome ribs
    ctx.strokeStyle = 'rgba(125,211,252,0.3)'; ctx.lineWidth = 2;
    for (let i = 0; i < 5; i++) {
      ctx.beginPath(); ctx.arc(400, 340, 120 + i * 60, Math.PI, 0); ctx.stroke();
    }
    ctx.font = 'bold 11px monospace'; ctx.fillStyle = 'rgba(125,211,252,0.75)';
    ctx.fillText('✦ CRYSTAL DOME OBSERVATORY ✦', 400, 342);
  } else if (sub === 'mr_base') {
    stars(ctx, t, 40, 180);
    // gold DJ deck
    ctx.fillStyle = '#111';
    ctx.fillRect(300, 150, 200, 66);
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 3;
    ctx.strokeRect(300, 150, 200, 66);
    for (let b = 0; b < 10; b++) {
      const bh = 6 + Math.abs(Math.sin(t * 0.14 + b)) * 24;
      ctx.fillStyle = `hsl(${(b * 36 + t * 4) % 360}, 90%, 60%)`;
      ctx.fillRect(312 + b * 18, 210 - bh, 10, bh);
    }
    ctx.font = 'bold 12px monospace'; ctx.fillStyle = '#FFD700';
    ctx.fillText('DJ THEGODS · LUNAR SET', 400, 174);
    // gold statue
    ctx.fillStyle = '#b8860b';
    ctx.fillRect(120, 220, 56, 90);
    ctx.fillStyle = '#FFD700';
    ctx.beginPath(); ctx.arc(148, 206, 18, 0, Math.PI * 2); ctx.fill();
    ctx.fillRect(134, 222, 28, 56);
    // THEGODS banner
    const rg2 = 0.6 + Math.abs(Math.sin(t * 0.07)) * 0.4;
    ctx.font = 'bold 26px serif';
    ctx.fillStyle = `rgba(255,215,0,${rg2})`;
    ctx.shadowColor = '#FFD700'; ctx.shadowBlur = 14 * rg2;
    ctx.fillText('⚡ THEGODS · MOON BASE ⚡', 400, 80);
    ctx.shadowBlur = 0;
    // porthole with Earth
    ctx.fillStyle = '#0b1120';
    ctx.beginPath(); ctx.arc(650, 200, 44, 0, Math.PI * 2); ctx.fill();
    ctx.strokeStyle = '#FFD700'; ctx.lineWidth = 4;
    ctx.beginPath(); ctx.arc(650, 200, 44, 0, Math.PI * 2); ctx.stroke();
    ctx.fillStyle = '#2563eb';
    ctx.beginPath(); ctx.arc(650, 200, 16, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = 'rgba(74,222,128,0.7)';
    ctx.beginPath(); ctx.ellipse(645, 196, 7, 4, 0.4, 0, Math.PI * 2); ctx.fill();
  }
  ctx.restore();
}

// ==================== SPACE FREE-FLIGHT ====================
export function drawShip(ctx, x, y, ang, t, thrusting) {
  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(ang + Math.PI / 2);
  if (thrusting) {
    const fl = 14 + Math.abs(Math.sin(t * 0.5)) * 14;
    ctx.fillStyle = '#22d3ee';
    ctx.beginPath(); ctx.moveTo(-7, 16); ctx.lineTo(0, 16 + fl); ctx.lineTo(7, 16); ctx.closePath(); ctx.fill();
  }
  // saucer body
  ctx.fillStyle = '#94a3b8';
  ctx.beginPath(); ctx.ellipse(0, 6, 26, 10, 0, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = '#cbd5e1';
  ctx.beginPath(); ctx.ellipse(0, 2, 20, 7, 0, 0, Math.PI * 2); ctx.fill();
  // cockpit bubble
  ctx.fillStyle = 'rgba(125,211,252,0.85)';
  ctx.beginPath(); ctx.arc(0, -4, 11, Math.PI, 0); ctx.fill();
  // ring lights
  for (let i = 0; i < 5; i++) {
    const on = (Math.floor(t / 10) + i) % 3 === 0;
    ctx.fillStyle = on ? '#f0abfc' : '#6b21a8';
    ctx.beginPath(); ctx.arc(-20 + i * 10, 8, 2.4, 0, Math.PI * 2); ctx.fill();
  }
  ctx.restore();
}

export function drawSpaceWorld(ctx, camX, camY, t, ship, others = []) {
  const cw = ctx.canvas.width, ch = ctx.canvas.height;
  ctx.fillStyle = '#02030c';
  ctx.fillRect(0, 0, cw, ch);
  // parallax stars
  for (let layer = 0; layer < 3; layer++) {
    const pf = 0.3 + layer * 0.35;
    for (let i = 0; i < 60; i++) {
      const sx = ((i * 173 + layer * 977) % SPACE_W - camX * pf + SPACE_W * 2) % SPACE_W;
      const sy = ((i * 271 + layer * 613) % SPACE_H - camY * pf + SPACE_H * 2) % SPACE_H;
      if (sx < 0 || sx > cw || sy < 0 || sy > ch) continue;
      const tw = 0.25 + Math.abs(Math.sin(t * 0.05 + i + layer)) * 0.6;
      ctx.fillStyle = `rgba(255,255,255,${tw})`;
      ctx.fillRect(sx, sy, layer + 1, layer + 1);
    }
  }
  ctx.save();
  ctx.translate(-camX, -camY);
  // Earth
  const eg = ctx.createRadialGradient(280, 240, 20, 300, 260, 100);
  eg.addColorStop(0, '#7dd3fc'); eg.addColorStop(0.6, '#2563eb'); eg.addColorStop(1, '#172554');
  ctx.fillStyle = eg;
  ctx.beginPath(); ctx.arc(300, 260, 95, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = 'rgba(74,222,128,0.7)';
  ctx.beginPath(); ctx.ellipse(270, 240, 34, 18, 0.5, 0, Math.PI * 2); ctx.fill();
  ctx.beginPath(); ctx.ellipse(330, 290, 24, 13, -0.4, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = 'rgba(255,255,255,0.3)';
  ctx.beginPath(); ctx.ellipse(300, 250, 76, 26, 0.6, 0, Math.PI * 2); ctx.fill();
  // landable planets
  PLANETS.forEach((p) => {
    if (p.id === 'saturn') {
      ctx.fillStyle = '#fbbf24';
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(251,191,36,0.55)'; ctx.lineWidth = 10;
      ctx.beginPath(); ctx.ellipse(p.x, p.y, p.r * 1.8, p.r * 0.45, -0.35, 0, Math.PI * 2); ctx.stroke();
    } else if (p.id === 'mars') {
      ctx.fillStyle = '#c2410c';
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(0,0,0,0.2)';
      ctx.beginPath(); ctx.arc(p.x - 14, p.y - 12, 10, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.arc(p.x + 16, p.y + 14, 7, 0, Math.PI * 2); ctx.fill();
    } else if (p.id === 'venus') {
      const vg = ctx.createRadialGradient(p.x - 14, p.y - 14, 6, p.x, p.y, p.r);
      vg.addColorStop(0, '#fde68a'); vg.addColorStop(1, '#ca8a04');
      ctx.fillStyle = vg;
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = 'rgba(253,230,138,0.5)'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.ellipse(p.x, p.y - 10, p.r * 0.8, 8, 0.15, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.ellipse(p.x, p.y + 14, p.r * 0.7, 7, -0.1, 0, Math.PI * 2); ctx.stroke();
    }
    const pg2 = 0.45 + Math.abs(Math.sin(t * 0.06 + p.x)) * 0.5;
    ctx.strokeStyle = `rgba(74,222,128,${pg2})`; ctx.lineWidth = 2.5;
    ctx.setLineDash([8, 7]);
    ctx.beginPath(); ctx.arc(p.x, p.y, p.r + 22, 0, Math.PI * 2); ctx.stroke();
    ctx.setLineDash([]);
    ctx.font = 'bold 12px monospace'; ctx.textAlign = 'center';
    ctx.fillStyle = `rgba(74,222,128,${pg2})`;
    ctx.fillText(`${p.name} · fly here to land`, p.x, p.y - p.r - 32);
  });
  // asteroids drifting
  for (let i = 0; i < 9; i++) {
    const ax = (900 + i * 190 + Math.sin(t * 0.01 + i) * 40) % SPACE_W;
    const ay = (500 + i * 137 + Math.cos(t * 0.008 + i * 2) * 30) % SPACE_H;
    ctx.fillStyle = '#57534e';
    ctx.beginPath(); ctx.arc(ax, ay, 8 + (i % 4) * 4, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = 'rgba(0,0,0,0.3)';
    ctx.beginPath(); ctx.arc(ax - 3, ay - 3, 3, 0, Math.PI * 2); ctx.fill();
  }
  // comet
  const cx2 = (t * 2.2) % (SPACE_W + 600) - 300;
  ctx.strokeStyle = 'rgba(165,243,252,0.5)'; ctx.lineWidth = 3;
  ctx.beginPath(); ctx.moveTo(cx2 - 90, 160 + cx2 * 0.12 - 12); ctx.lineTo(cx2, 160 + cx2 * 0.12); ctx.stroke();
  ctx.fillStyle = '#e0f2fe';
  ctx.beginPath(); ctx.arc(cx2, 160 + cx2 * 0.12, 6, 0, Math.PI * 2); ctx.fill();
  // satellite
  ctx.save();
  ctx.translate(1150, 750); ctx.rotate(t * 0.01);
  ctx.fillStyle = '#cbd5e1'; ctx.fillRect(-8, -14, 16, 28);
  ctx.fillStyle = '#1d4ed8'; ctx.fillRect(-42, -8, 28, 16); ctx.fillRect(14, -8, 28, 16);
  ctx.restore();
  // the Moon — landing zone
  const mg = ctx.createRadialGradient(SPACE_MOON.x - 20, SPACE_MOON.y - 20, 10, SPACE_MOON.x, SPACE_MOON.y, SPACE_MOON.r);
  mg.addColorStop(0, '#e5e7eb'); mg.addColorStop(1, '#6b7280');
  ctx.fillStyle = mg;
  ctx.beginPath(); ctx.arc(SPACE_MOON.x, SPACE_MOON.y, SPACE_MOON.r, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = 'rgba(0,0,0,0.15)';
  [[-30, -20, 16], [24, 10, 12], [-6, 34, 9], [36, -34, 8]].forEach(([ox, oy, r]) => {
    ctx.beginPath(); ctx.arc(SPACE_MOON.x + ox, SPACE_MOON.y + oy, r, 0, Math.PI * 2); ctx.fill();
  });
  const lg = 0.5 + Math.abs(Math.sin(t * 0.06)) * 0.5;
  ctx.strokeStyle = `rgba(74,222,128,${lg})`; ctx.lineWidth = 3;
  ctx.setLineDash([10, 8]);
  ctx.beginPath(); ctx.arc(SPACE_MOON.x, SPACE_MOON.y, SPACE_MOON.r + 26, 0, Math.PI * 2); ctx.stroke();
  ctx.setLineDash([]);
  ctx.font = 'bold 13px monospace'; ctx.textAlign = 'center';
  ctx.fillStyle = `rgba(74,222,128,${lg})`;
  ctx.fillText('🌕 FLY HERE TO LAND', SPACE_MOON.x, SPACE_MOON.y - SPACE_MOON.r - 38);
  // other cruisers
  others.forEach((o) => drawShip(ctx, o.x, o.y, o.ang || 0, t, o.walking));
  // my ship
  drawShip(ctx, ship.x, ship.y, ship.ang, t, ship.thrusting);
  ctx.restore();
}
